<script lang="ts" setup>
import type { HTMLAttributes } from "vue"
import { DrawerOverlay } from "vaul-vue"
import { cn } from "@/lib/utils"

defineOptions({ inheritAttrs: false })

const props = defineProps<{ class?: HTMLAttributes["class"] }>()
</script>

<template>
  <DrawerOverlay
    data-slot="drawer-overlay"
    v-bind="$attrs"
    :class="cn('data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 bg-black/10 supports-backdrop-filter:backdrop-blur-xs fixed inset-0 z-50', props.class)"
  />
</template>
